import { render, staticRenderFns } from "./MyOrderRail.vue?vue&type=template&id=54aba20f&scoped=true"
import script from "./MyOrderRail.vue?vue&type=script&lang=js"
export * from "./MyOrderRail.vue?vue&type=script&lang=js"
import style0 from "./MyOrderRail.vue?vue&type=style&index=0&id=54aba20f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aba20f",
  null
  
)

export default component.exports